import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function ProtectedRoute() {
  const { isAuthenticated, user } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    // Redirect to login but save the attempted URL
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Check if email is verified
  if (user && !user.emailVerified) {
    return <Navigate to="/resend-verification" state={{ from: location }} replace />;
  }

  return <Outlet />;
}
